import { createSelector } from '@reduxjs/toolkit';

/**
 * Memoized selector for calls formatted for search.
 * Only recalculates when the call queue actually changes.
 */
const selectCalls = createSelector(
  [state => state.emergencyCalls.callQueue],
  callQueue => {
    if (!callQueue) {
      return {
        keys: ['_callId'],
        data: [],
      };
    }

    const calls = Object.keys(callQueue).map(k => ({
      ...(callQueue[k] || {}),
      _callId: k,
      _datasetName: 'calls',
    }));

    return {
      keys: ['_callId'],
      data: calls,
    };
  },
);

export default selectCalls;
